<template>
<div>
  <v-dialog
    v-if="!error.createCorpClient.length && !resultsCreated.createCorpClient.success"
    :value="openModal"
    persistent
    @close="closeModal"
    max-width="600"
    :content-class="'ModalsCreateCorpClient'"
  >
    <v-card
      class="ModalsCreateCorpClient__card d-flex flex-column px-6 py-4"
      :loading="loading.createCorpClient"
    >
      <div
        v-if="!loading.createCorpClient "
        class="ModalsCreateCorpClient__card d-flex flex-column px-6 pt-4"

      >
        <div class="ModalsCreateCorpClient__close d-flex justify-end">
          <v-btn
            small
            @click="closeModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <div class="ModalsCreateCorpClient__header">
          <div class="ModalsCreateCorpClient__title">
            <span >Стать корпоративным клиентом</span>
          </div>
          <div class="ModalsCreateCorpClient__subTitle">
            Свяжитесь с менеджером через Telegram или заполните форму ниже — мы свяжемся с вами, чтобы обсудить условия и ответить на вопросы.
          </div>
          <div class="ModalsCreateCorpClient__btn-group">
            <v-btn
              class="tg-btn"
              outlined
              @click="goToTelegram"
            >
              <span class="pr-2">
                Связаться с менеджером
              </span>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_5689_30476)">
                  <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37259 18.6274 0 12 0C5.37259 0 0 5.37259 0 12C0 18.6274 5.37259 24 12 24Z" fill="#34AADF"/>
                  <path d="M4.9942 11.893C4.9942 11.893 10.9942 9.43056 13.0751 8.56349C13.8728 8.21669 16.578 7.10683 16.578 7.10683C16.578 7.10683 17.8266 6.62131 17.7225 7.80048C17.6878 8.28605 17.4104 9.98544 17.1329 11.8236C16.7167 14.4248 16.2658 17.2687 16.2658 17.2687C16.2658 17.2687 16.1965 18.0664 15.6069 18.2051C15.0173 18.3438 14.0462 17.7196 13.8728 17.5808C13.734 17.4768 11.2716 15.9161 10.3699 15.1531C10.1271 14.945 9.84968 14.5288 10.4046 14.0433C11.6531 12.8988 13.1445 11.4768 14.0462 10.5751C14.4624 10.1589 14.8785 9.18778 13.1445 10.3669C10.6821 12.0664 8.25431 13.6618 8.25431 13.6618C8.25431 13.6618 7.69938 14.0086 6.65893 13.6964C5.61844 13.3843 4.40456 12.9681 4.40456 12.9681C4.40456 12.9681 3.57224 12.4479 4.9942 11.893Z" fill="white"/>
                </g>
                <defs>
                  <clipPath id="clip0_5689_30476">
                    <rect width="24" height="24" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
            </v-btn>
          </div>
        </div>
        <div class="d-flex">
          <v-divider
            class="mx-2 h-100"
          />
        </div>
        <div class="ModalsCreateCorpClient__form">
          <div class="w-100 field">
            <p>Компания</p>
            <v-text-field
              v-model="fieldCompany"
              :class="'full'"
              :placeholder="'Введите название компании'"
              :value="fieldCompany"
              :dense="true"
              :outlined="true"
              :hide-details="true"
            />
            <div class="text-error pt-1">
              {{getFieldError('company')}}
            </div>
          </div>
          <div class="w-100 field">
            <p>Электронная почта</p>
            <v-text-field
              v-model="fieldEmail"
              :class="'full'"
              :placeholder="'Введите email '"
              :value="fieldEmail"
              :dense="true"
              :outlined="true"
              :hide-details="true"
            />
            <div class="text-error pt-1">
              {{getFieldError('email')}}
            </div>
          </div>
          <div class="w-100 field">
            <p>Номер телефона</p>
            <v-text-field
              v-model="fieldNumber"
              :class="'full'"
              :placeholder="'+7 (_ _ _) _ _ _-_ _ -_ _'"
              :value="fieldNumber"
              :dense="true"
              :outlined="true"
              :hide-details="true"
            />
            <div class="text-error pt-1">
              {{getFieldError('number')}}
            </div>
          </div>
          <div class="w-100 field">
            <p>Имя в Telegram</p>
            <v-text-field
              v-model="fieldTg"
              :class="'full'"
              :placeholder="'Введите имя в Telegram'"
              :value="fieldTg"
              :dense="true"
              :outlined="true"
              :hide-details="true"
              prefix="@"
            />
            <div class="text-error pt-1">
              {{getFieldError('telegram')}}
            </div>
          </div>
        </div>
        <div class="ModalsCreateCorpClient__btn-group">
          <div>
            <v-btn
              class="mr-3 _w-100"
              outlined
              color="primary"
              @click="cancel"
            >
              Отменить
            </v-btn>
          </div>
          <div>
            <v-btn
              class="_w-100"
              color="primary"
              @click="createClient"
            >
              Отправить заявку
            </v-btn>
          </div>
        </div>
      </div>
      <div
        v-if="loading.createCorpClient"
        class="ModalsCreateCorpClient__loading text-center">
        Идет отправка данных...
      </div>
    </v-card>
  </v-dialog>
  <ModalWithAction
    v-if="error.createCorpClient.length > 0"
    title="Заявка не отправлена"
    image-slot
    :show-modal="error.createCorpClient.length > 0"
    :text="`Попробуйте еще раз или свяжитесь с менеджером ${error.createCorpClient[0].error || ''}`"
    :cancel-button="true"
    :accept-button="'Связаться с менеджером'"
    @accept="goToTelegram"
    @closeModal="closeModal"
  >
    <template v-slot:image>
      <div class="d-flex justify-center">
        <v-img
          class="text-center"
          src="@/assets/images/adminPanel/failed.webp"
          max-width="86px"
        />
      </div>
    </template>
  </ModalWithAction>
  <ModalWithAction
    title="Заявка отправлена"
    :image-slot="false"
    :text="'На вашу почту направлены логин и пароль <br>  для перехода в кабинет корпоративного клиента. <br> Если у вас остались вопросы — свяжитесь с менеджером.'"
    :show-modal="resultsCreated.createCorpClient.success"
    :cancel-button="true"
    :accept-button="'Связаться с менеджером'"
    width-modal="586"
    @accept="goToTelegram"
    @closeModal="closeModal"
  >
    <template v-slot:image>
      <div class="d-flex justify-center">
        <v-img
          class="text-center"
          src="@/assets/images/adminPanel/success.webp"
          max-width="86px"
        />
      </div>
    </template>
  </ModalWithAction>
</div>
</template>

<script>

import { minLength, required } from 'vuelidate/lib/validators';
import { VueMaskDirective } from 'v-mask';
import Vue from 'vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import ModalWithAction from '@/components/admin-panel/Modal/ModalWithAction.vue';

/**
 * Компонент: ModalsCreateCorpClient
 * Описание:
 */
export default {
  name: 'ModalsCreateCorpClient',

  components: { ModalWithAction },

  props: {
    openModal: {
      type: Boolean,
      default: false
    },
  },
  emits: ['closeModal'],
  validations() {
    const rules = {
      company: {
        required,
        minLength: minLength(5),
      },
      email: {
        required,
        minLength: minLength(5),
      },
      number: {
        required,
        minLength: minLength(5),
      },
      telegram: {
        required,
        minLength: minLength(5),
      }
    };
    return {
      formValues: rules
    };
  },
  directives: {
    mask: VueMaskDirective,
  },

  data() {
    const fieldCompany = '';
    const fieldEmail = '';
    const fieldNumber = '';
    const fieldTg = '';
    const formValues = {};
    const showFailedModal = false;
    const showSuccessModal = true;

    return {
      fieldCompany,
      fieldNumber,
      fieldEmail,
      fieldTg,
      formValues,
      showFailedModal,
      showSuccessModal,
    };
  },

  computed: {
    ...mapGetters({
      loading: 'users/candidate/loading',
      error: 'users/candidate/errors',
      resultsCreated: 'users/candidate/resultsCreated'
    })
  },

  watch: {
    fieldCompany(val) {
      this.$set(this.formValues, 'company', val);
    },
    fieldEmail(val) {
      this.$set(this.formValues, 'email', val);
    },
    fieldNumber(val) {
      this.$set(this.formValues, 'number', val);
    },
    fieldTg(val) {
      this.$set(this.formValues, 'telegram', val);
    }
  },

  created() {
  },

  mounted() {
  },

  beforeDestroy() {
  },

  methods: {
    ...mapActions({
      createCorporateClient: 'users/candidate/createCorporateClient',
    }),
    ...mapMutations({
      resetCreate: 'users/candidate/resetCreateCorpClient',
    }),
    closeModal() {
      this.fieldCompany = '';
      this.fieldNumber = '';
      this.fieldTg = '';
      this.fieldEmail = '';
      this.resetCreate();
      this.$emit('closeModal');
    },
    getFieldError(fieldEmail) {
      const validator = this.$v.formValues[fieldEmail];
      if (!validator || !validator.$error) return '';
      if (validator.required === false) {
        return 'Это поле обязательно';
      }
      if (validator.minLength === false) {
        return `Минимум ${validator.$params.minLength.min} символов`;
      }
      if (validator.maxSize === false) {
        return 'Макс. размер  5 МБ';
      }
      if (validator.format === false) {
        return 'Не допустимый формат';
      }
      return 'Ошибка валидации';
    },
    validateForm() {
      if (this.$v.formValues.company) {
        this.$v.formValues.company.$touch();
      }
      if (this.$v.formValues.email) {
        this.$v.formValues.email.$touch();
      }
      if (this.$v.formValues.number) {
        this.$v.formValues.number.$touch();
      }
      if (this.$v.formValues.telegram) {
        this.$v.formValues.telegram.$touch();
      }
    },
    cancel() {
      this.closeModal();
    },
    async createClient() {
      this.validateForm();
      if (this.$v.$invalid) {
        Vue.prototype.$toast.error('Форма заполнена некорректно', '', { position: 'bottomCenter' });
        return;
      }
      const data = {
        email: this.fieldEmail,
        company: this.fieldCompany,
        telephone: this.fieldNumber,
        telegram: `@${this.fieldTg}`,
      };
      await this.createCorporateClient(data);
    },
    goToTelegram() {
      window.open('https://t.me/Team_Assessment', '_blank');
    },
  },
};
</script>

<style scoped lang="scss">
  .ModalsCreateCorpClient {
    &__header{
      display: flex;
      flex-direction: column;
      gap: 20px;
    }
    &__card {
      border-radius: 20px !important;
      box-shadow: none !important;
      gap: 24px;
    }

    &__close {
      & > button {
        box-shadow: none !important;
        background: transparent;
      }
    }

    &__title {
      font-size: 22px;
      color: var(--color-blue-500);
      font-weight: 600;
    }

    &__btn-group {
      display: flex;
      & .v-btn.tg-btn{
        background: #34AADF;
        color: white;
        border: none;
        border-radius: 6px;
        height: 100%;
        font-size: 16px;
        padding: 16px 16px;
        font-weight: 600;
        max-height: 52px;
        ::v-deep span{
          line-height: 24px;
        }
      }
    }

    &__form{
      display: flex;
      flex-direction: column;
      gap: 16px;
      & .field{
        & p{
          margin: 12px 0 8px;
        }
      }
      & .v-input.full {
        ::v-deep .v-input__control{
          border-radius: 8px;
          border: 1px solid var(--color-grey-200);
          & .v-input__slot:hover fieldset{
            color: var(--color-blue-500)!important;
          }
        }
        &.v-input--is-focused fieldset{
          color: var(--color-blue-500)!important;
          border: 1px solid var(--color-blue-500)!important;
        }
      }
      & .image-field .error-image{
        padding: 4px;
        border-radius: 10px;
        outline: 2px dashed var(--v-error-base);
        color:  var(--v-error-base);
      }
    }

  }
</style>
